module.exports = __webpack_public_path__ + "assets/img/8.65e619ee.jpg";